import { render, staticRenderFns } from "./ClazOrGroupSlot.vue?vue&type=template&id=cef83484&scoped=true"
import script from "./ClazOrGroupSlot.vue?vue&type=script&lang=js"
export * from "./ClazOrGroupSlot.vue?vue&type=script&lang=js"
import style0 from "./ClazOrGroupSlot.vue?vue&type=style&index=0&id=cef83484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef83484",
  null
  
)

export default component.exports